import React, { useState } from 'react';
import { CheckIcon, ChevronDownIcon, ShieldCheckIcon } from 'lucide-react';
interface OfferCardProps {
  featured?: boolean;
}
function ArtrosisAccordion() {
  const [open, setOpen] = useState(false);
  return <div className="mt-4 border border-gold/40 rounded-xl overflow-hidden bg-navy/40" data-id="element-69">
      <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} className="w-full flex items-center justify-between gap-3 text-left px-4 py-3 text-gold font-semibold text-sm hover:bg-white/5 transition-colors" data-id="element-70">
        <span data-id="element-71">¿Qué incluye el Super Pack pacientes con artrosis?</span>
        <ChevronDownIcon className={`w-5 h-5 flex-shrink-0 transition-transform duration-300 ${open ? 'rotate-180' : ''}`} data-id="element-72" />
      </button>
      <div className={`grid transition-all duration-300 ease-in-out ${open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-73">
        <div className="overflow-hidden" data-id="element-74">
          <div className="px-4 pb-4 text-sm text-gray-300/80 leading-relaxed space-y-4" data-id="element-75">
            <p data-id="element-76">
              La artrosis no tiene por qué quitarle su independencia. Actuar a
              tiempo puede marcar una gran diferencia. Este programa reúne
              ejercicios adaptados, rutinas de fortalecimiento, hábitos
              saludables y herramientas de seguimiento para ayudar a mantener la
              movilidad, proteger las articulaciones y recuperar la confianza en
              las actividades del día a día.
            </p>
            <div data-id="element-77">
              <h5 className="font-bold text-white mb-1" data-id="element-78">
                🚶 Módulo 1 · Movilidad Articular y Ejercicios Adaptados
              </h5>
              <p data-id="element-79">
                Aprende a realizar más de 70 ejercicios especialmente adaptados
                para personas con artrosis, diseñados para favorecer la
                movilidad de las articulaciones, reducir la rigidez y mantener
                la independencia de forma segura.
              </p>
            </div>
            <div data-id="element-80">
              <h5 className="font-bold text-white mb-1" data-id="element-81">
                💪 Módulo 2 · Fortalecimiento Muscular y Bienestar Físico
              </h5>
              <p data-id="element-82">
                Rutinas progresivas adaptadas para pacientes con artrosis,
                enfocadas en fortalecer los músculos que protegen las
                articulaciones, mejorar el equilibrio y facilitar las
                actividades del día a día.
              </p>
            </div>
            <div data-id="element-83">
              <h5 className="font-bold text-white mb-1" data-id="element-84">
                🥗 Módulo 3 · Alimentación y Hábitos Saludables
              </h5>
              <p data-id="element-85">
                Una guía práctica creada para personas con artrosis, con
                recomendaciones de alimentación, hábitos saludables, menús,
                recetas y estrategias que complementan un estilo de vida activo
                y favorecen el bienestar general.
              </p>
            </div>
            <div data-id="element-86">
              <h5 className="font-bold text-white mb-1" data-id="element-87">
                📋 Módulo 4 · Plan Integral de Seguimiento
              </h5>
              <p data-id="element-88">
                Lleva un control completo de tu evolución con un planner
                especialmente diseñado para pacientes con artrosis, donde podrás
                registrar ejercicios, movilidad, bienestar, objetivos y
                progresos para mantener la constancia y la motivación.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}
function OfferCard({
  featured = false
}: OfferCardProps) {
  const baseIncludes = ['Super Pack Completo (13 Módulos)', 'Módulo PREMIUM de Ejercicios', 'Bono 1: Calendario de 30 Dias de Ejercicios Cognitivos', 'Bono 2: Juegos Interactivos para Gimnasia Cerebral', 'Bono 3: Cuaderno de Estimulación Emocional'];
  return <div className={`relative rounded-3xl p-8 md:p-10 flex flex-col shadow-panel transition-transform duration-300 ${featured ? 'bg-navy-deep border-2 border-gold lg:scale-[1.04] z-10' : 'bg-navy border border-white/10'}`} data-id="element-89">
      {featured && <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold text-navy-deep font-bold px-6 py-1.5 rounded-full text-xs uppercase tracking-wider shadow-lg whitespace-nowrap" data-id="element-90">
          ⭐ El más elegido
        </div>}

      <h3 className="text-white font-bold text-xl mb-1" data-id="element-91">
        {featured ? 'Pack Completo + Artrosis' : 'Pack Esencial'}
      </h3>
      <p className="text-gray-400 text-sm mb-6" data-id="element-92">
        {featured ? 'Todo el sistema, los 3 bonos y el Super Pack de artrosis.' : 'El sistema completo con los 3 bonos.'}
      </p>

      <div className="mb-6" data-id="element-93">
        <div className="flex items-baseline gap-1 text-white" data-id="element-94">
          <span className="text-2xl font-bold" data-id="element-95">$</span>
          <span className="text-5xl md:text-6xl font-black tracking-tighter" data-id="element-96">
            {featured ? '27.990' : '19.990'}
          </span>
        </div>
        <p className="text-coral-strong text-sm mt-1 font-medium" data-id="element-97">
          Único pago. Acceso de por vida.
        </p>
      </div>

      <ul className="space-y-3 mb-6" data-id="element-98">
        {baseIncludes.map((item, i) => <li key={i} className="flex items-start text-gray-200 text-sm" data-id="element-99">
            <CheckIcon className="w-5 h-5 text-cta mr-2 flex-shrink-0 mt-0.5" data-id="element-100" />
            <span data-id="element-101">{item}</span>
          </li>)}
        {featured && <li className="flex items-start text-gold font-semibold text-sm" data-id="element-102">
            <CheckIcon className="w-5 h-5 text-cta mr-2 flex-shrink-0 mt-0.5" data-id="element-103" />
            <span data-id="element-104">Super Pack Pacientes con Artrosis</span>
          </li>}
      </ul>

      {featured && <ArtrosisAccordion data-id="element-105" />}

      <div className="mt-auto pt-8" data-id="element-106">
        <a href="#" className={`w-full inline-flex items-center justify-center font-bold text-base md:text-lg py-4 px-6 rounded-lg transition-all duration-300 transform hover:-translate-y-1 ${featured ? 'bg-cta hover:bg-cta-hover text-black shadow-cta hover:shadow-cta-hover' : 'bg-white/10 hover:bg-white/20 text-white border border-white/20'}`} data-id="element-107">
          {featured ? 'Quiero la oferta más elegida' : 'Quiero esta oferta'}
        </a>
      </div>
    </div>;
}
export function PricingSection() {
  return <section id="precio-lanzamiento" className="w-full bg-sky py-20 px-5 sm:px-8 lg:px-12 pt-[30px]" data-id="element-108">
      <div className="max-w-6xl mx-auto" data-id="element-109">
        <div className="text-center mb-16" data-id="element-110">
          <h2 className="font-serif text-navy text-3xl md:text-5xl font-bold mb-6" data-id="element-111">
            Empezá a cuidar con{' '}
            <span className="text-[#FF811B]" data-id="element-112">seguridad y tranquilidad</span> hoy
            mismo
          </h2>
          <p className="text-navy/70 text-lg max-w-2xl mx-auto" data-id="element-113">
            Elegí la opción que mejor se adapta a lo que necesitás. Acceso
            inmediato a todo el material.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-4xl mx-auto items-stretch" data-id="element-114">
          <OfferCard featured data-id="element-115" />
          <OfferCard data-id="element-116" />
        </div>

        <div className="mt-10 flex flex-wrap justify-center items-center gap-6 text-navy/70 text-sm" data-id="element-117">
          <span className="inline-flex items-center gap-2" data-id="element-118">
            <ShieldCheckIcon className="w-4 h-4 text-coral-strong" data-id="element-119" /> Garantía
            de satisfacción de 7 días
          </span>
          <span className="inline-flex items-center gap-2" data-id="element-120">
            🔒 Compra 100% segura y encriptada
          </span>
        </div>
      </div>
    </section>;
}